import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trackLead, trackButtonClick, trackViewContent } from "../services/facebookAPI";
import "../App.css";
import product from "../Assets/images/Supergro.png";
import beforeAfter from "../Assets/images/Before and after.jpeg";
import tomatoes from "../Assets/images/Lagos tomatoes.jpeg";
import alhaji from "../Assets/images/Rice farm alhaji.png";
import maize from "../Assets/images/Maize farm.jpeg";
import vegetable from "../Assets/images/Vegetable.jpeg";
import fruit from "../Assets/images/Fruit Farm.jpeg";
import cocoa from "../Assets/images/Cocoa far.jpeg";
import fishPond from "../Assets/images/Fish farm.jpeg";
import poultry from "../Assets/images/Poultry.jpeg";
import farm from "../Assets/images/Farm.png";
import chika from "../Assets/images/Chika.png";
import riceFarm from "../Assets/images/Rice farm.png";
import fishholding from "../Assets/images/Fish holding.png";
import plantain from "../Assets/images/Plantain.png";
import pepper from "../Assets/images/Pepper farm.png";
import logo from "../Assets/images/logo.png";

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  // Track product view when page loads
  useEffect(() => {
    trackViewContent();
    console.log("🏠 HomePage loaded - Facebook tracking active");
  }, []);

  // Handle all order button clicks with Facebook tracking
  const handleOrderClick = (buttonName: string, sectionName?: string) => {
    // Track as a lead (someone showing interest)
    trackLead(buttonName);
    
    // Track specific button click
    trackButtonClick(buttonName, sectionName || 'general');
    
    console.log(`🛒 User clicked "${buttonName}" - Redirecting to checkout`);
    navigate("/checkout");
  };

  return (
    <div className="home-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5px' }}>
  <img
    src={logo}
    alt="The Peters Agriculture Logo"
    style={{ width: '64px', height: '48px', objectFit: 'contain' }}
  />
  <div>
    <div style={{ fontSize: '1.25rem', fontWeight: 'bold', lineHeight: '1.2' }}>
      THE PETERS
    </div>
    <div style={{ fontSize: '0.875rem', color: '#fb923c', fontWeight: 600 }}>
      Agriculture
    </div>
  </div>
</div>
            <button
              className="btn btn-primary mobile-hidden"
              onClick={() => handleOrderClick("header_order_button", "header")}
            >
              ORDER NOW →
            </button>
            <button
              className="btn btn-primary mobile-only"
              onClick={() => handleOrderClick("mobile_header_order_button", "header")}
            >
              ORDER NOW →
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h2>
                Transform Your Farm Income by{" "}
                <span className="highlight-green">40% This Season</span>
              </h2>
              <h1 className="product-title">Super Gro Organic Fertilizer</h1>
              <p className="subtitle">
                5 Liters | The Secret Weapon of Successful Nigerian Farmers
              </p>

              {/* Product Image for Mobile */}
              <div className="mobile-product-image">
                <div className="image-container">
                  <img
                    src={product}
                    alt="Super Gro Organic Fertilizer"
                    className="product-img"
                  />
                </div>
                <div className="product-tag">Professional Grade • 5 Liters</div>
              </div>

              <div className="price-display">
                <div className="price-section">
                  <span className="price-strike">₦90,500</span>
                  <span className="price">₦55,000</span>
                  <span className="badge badge-success">
                    Save ₦10,500 Today Only
                  </span>
                </div>
                <p className="delivery-info">
                  🚚 Fast Nationwide Delivery | 48-72 Hours to Your Doorstep
                </p>
              </div>

              <button
                className="btn btn-secondary cta-button"
                onClick={() => handleOrderClick("hero_cta_button", "hero_section")}
              >
                👉 YES! I WANT BIGGER HARVESTS
              </button>

              <p className="order-count">
                ⚡ 127 farmers ordered in the last 24 hours
              </p>
            </div>

            {/* Product Image for Desktop */}
            <div className="hero-image desktop-only">
              <div className="product-image-placeholder">
                <div className="image-container">
                  <img
                    src={product}
                    alt="Super Gro Organic Fertilizer"
                    className="product-img"
                  />
                </div>
                <div className="product-tag">Professional Grade • 5 Liters</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bulk Discount Offers */}
<section className="bulk-offers">
  <div className="container">
    <h2 className="section-title">
      Buy More, Save More! <span className="highlight-green">Get ₦5,000 Discount Per Extra Unit</span>
    </h2>
    <p className="section-subtitle">
      Stock up and maximize your farm's potential – the more you buy, the more you save!
    </p>

    <div className="bulk-cards">
      {/* Card for 1 unit */}
      <div className="bulk-card">
        <div className="bulk-quantity">1 Unit</div>
        <div className="bulk-price">
          <span className="original-price">₦90,500</span>
          <span className="discounted-price">₦55,000</span>
        </div>
        <div className="bulk-savings">Save ₦15</div>
        <button
          className="btn btn-primary btn-block"
          onClick={() => handleOrderClick("bulk_buy_1_unit", "bulk_offers")}
        >
          ORDER 1 UNIT
        </button>
      </div>

      {/* Card for 2 units */}
      <div className="bulk-card recommended">
        <div className="card-header">
          <span className="badge badge-success">BEST VALUE ⭐</span>
        </div>
        <div className="bulk-quantity">2 Units</div>
        <div className="bulk-price">
          <span className="original-price">₦140,000</span>
          <span className="discounted-price">₦105,000</span>
        </div>
        <div className="bulk-savings">You save ₦35,000</div>
        <button
          className="btn btn-secondary btn-block"
          onClick={() => handleOrderClick("bulk_buy_2_units", "bulk_offers")}
        >
          ORDER 2 UNITS
        </button>
      </div>

      {/* Card for 3 units */}
      <div className="bulk-card">
        <div className="bulk-quantity">3 Units</div>
        <div className="bulk-price">
          <span className="original-price">₦210,000</span>
          <span className="discounted-price">₦155,000</span>
        </div>
        <div className="bulk-savings">You save ₦50,000</div>
        <button
          className="btn btn-primary btn-block"
          onClick={() => handleOrderClick("bulk_buy_3_units", "bulk_offers")}
        >
          ORDER 3 UNITS
        </button>
      </div>
    </div>

    <p className="bulk-note">
      💡 Discount applies automatically at checkout. For larger quantities, please call us.
    </p>
  </div>
</section>


      {/* Social Proof Banner */}
      <section className="social-proof">
        <div className="container">
          <p>
            ⭐⭐⭐⭐⭐ Trusted by Over 10,500 Nigerian Farmers | 98% Success Rate
          </p>
        </div>
      </section>

      {/* Before & After Results Section */}
      <section className="results-showcase">
        <div className="container">
          <h2 className="section-title">
            See The Proof: Real Results From Real Farms
          </h2>
          <p className="section-subtitle">
            These are actual results from Nigerian farmers who trusted Super Gro
          </p>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="image-container">
                <img
                  src={beforeAfter}
                  alt="Maize harvest comparison"
                  className="responsive-img"
                />
              </div>
              <h3>40% Bigger Maize Harvest</h3>
              <p>
                Mr. Okonkwo's farm in Enugu - From 2.5 tons to 3.5 tons per acre
                using Super Gro
              </p>
            </div>

            <div className="benefit-card">
              <div className="image-container">
                <img
                  src={tomatoes}
                  alt="Tomato farm"
                  className="responsive-img"
                />
              </div>
              <h3>Doubled Tomato Yield</h3>
              <p>
                Mrs. Blessing's greenhouse in Lagos - Healthier plants, zero
                disease, maximum profit
              </p>
            </div>

            <div className="benefit-card">
              <div className="image-container">
                <img
                  src={alhaji}
                  alt="Rice farm transformation"
                  className="responsive-img"
                />
              </div>
              <h3>Rice Farm Transformation</h3>
              <p>
                Alhaji Musa's rice farm in Kano - Stronger stalks, fuller
                grains, earlier harvest
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Problem Section */}
      <section className="problem-section">
        <div className="container">
          <h2 className="section-title problem-title">
            Are You Losing Money Because Your Crops Are Underperforming?
          </h2>

          <div className="problem-container">
            <div className="problem-box">
              <h3>The Harsh Reality Most Farmers Face:</h3>
              <ul>
                <li>✗ Weak, stunted plant growth despite watering</li>
                <li>✗ Poor yields that barely cover your investment</li>
                <li>✗ Crops vulnerable to disease and pests</li>
                <li>✗ Depleted soil that refuses to produce</li>
                <li>✗ Expensive chemical fertilizers that burn your crops</li>
                <li>✗ Watching your neighbors harvest more while you struggle</li>
              </ul>
            </div>

            <div className="solution-box">
              <h3>What Changes When You Use Super Gro:</h3>
              <ul>
                <li>✓ Explosive root development within 7 days</li>
                <li>✓ Darker green leaves showing optimal health</li>
                <li>✓ 30-40% increase in final harvest weight</li>
                <li>✓ Natural disease resistance built into every plant</li>
                <li>✓ Soil enrichment that lasts for seasons</li>
                <li>✓ Your farm becomes the talk of the community</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* What Makes Super Gro Different */}
      <section className="benefits">
        <div className="container">
          <h2 className="section-title">
            Why Super Gro Outperforms Every Other Fertilizer
          </h2>
          <p className="section-subtitle">
            This isn't just fertilizer - it's a complete plant growth system
          </p>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">🌱</div>
              <h3>100% Organic & Safe</h3>
              <p>
                Made from premium humic acid, seaweed extract, and beneficial
                microorganisms. No harmful chemicals that damage your soil or
                poison your crops.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">📈</div>
              <h3>Scientifically Proven Results</h3>
              <p>
                Laboratory tested and field proven across Nigeria. Increases
                nutrient absorption by 85%, accelerates photosynthesis.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">💰</div>
              <h3>Incredibly Cost Effective</h3>
              <p>
                One 5L gallon treats 1-2 acres for an entire growing season.
                Your ROI can be 300% or more.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">⚡</div>
              <h3>Fast Visible Results</h3>
              <p>
                Within 2 weeks, you'll see darker leaves and stronger stems. By
                week 4, your neighbors will ask what you're using.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🛡️</div>
              <h3>Natural Disease Protection</h3>
              <p>
                The beneficial microbes create a protective shield around roots
                and leaves. Your crops develop stronger immunity to diseases.
              </p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon">🌾</div>
              <h3>Soil Regeneration</h3>
              <p>
                Unlike chemical fertilizers, Super Gro rebuilds your soil's
                natural fertility. Your land becomes more productive year after
                year.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Application in Different Farming Types */}
      <section className="applications">
        <div className="container">
          <h2 className="section-title">Works For Every Type of Farming</h2>
          <p className="section-subtitle">
            One powerful solution for all your farming needs
          </p>

          <div className="applications-grid">
            <div className="application-card">
              <div className="image-container">
                <img src={maize} alt="Maize farm" className="responsive-img" />
              </div>
              <h3>🌾 Crop Farming</h3>
              <p>
                <strong>Perfect for:</strong> Maize, rice, cassava, yam, beans,
                millet, sorghum
              </p>
              <p>
                <strong>Results:</strong> 30-40% yield increase, stronger stalks
                that resist lodging
              </p>
            </div>

            <div className="application-card">
              <div className="image-container">
                <img src={vegetable} alt="Vegetable farm" className="responsive-img" />
              </div>
              <h3>🥬 Vegetable Farming</h3>
              <p>
                <strong>Perfect for:</strong> Tomatoes, peppers, cucumber,
                lettuce, cabbage
              </p>
              <p>
                <strong>Results:</strong> Larger fruits, deeper colors, extended
                harvest period
              </p>
            </div>

            <div className="application-card">
              <div className="image-container">
                <img src={fruit} alt="Fruit farm" className="responsive-img" />
              </div>
              <h3>🍊 Fruit Farming</h3>
              <p>
                <strong>Perfect for:</strong> Oranges, mangoes, pawpaw,
                pineapple, banana
              </p>
              <p>
                <strong>Results:</strong> Sweeter fruits, better flowering,
                increased fruit set
              </p>
            </div>

            <div className="application-card">
              <div className="image-container">
                <img src={cocoa} alt="Cocoa farm" className="responsive-img" />
              </div>
              <h3>🍫 Cash Crop Farming</h3>
              <p>
                <strong>Perfect for:</strong> Cocoa, oil palm, rubber, cashew,
                coffee
              </p>
              <p>
                <strong>Results:</strong> Healthier trees, increased pod/fruit
                production
              </p>
            </div>

            <div className="application-card">
              <div className="image-container">
                <img src={fishPond} alt="Fish farm" className="responsive-img" />
              </div>
              <h3>🐟 Fish Farming</h3>
              <p>
                <strong>Revolutionary for aquaculture!</strong> Boost natural
                food production
              </p>
              <p>
                <strong>Results:</strong> Fish grow 25% faster, healthier fish
                with better coloration
              </p>
            </div>

            <div className="application-card">
              <div className="image-container">
                <img src={poultry} alt="Poultry farm" className="responsive-img" />
              </div>
              <h3>🐔 Poultry Farming</h3>
              <p>
                <strong>Boost your feed quality!</strong> Use Super Gro on the
                grasses and vegetables
              </p>
              <p>
                <strong>Results:</strong> More nutritious feed, better egg
                production, healthier birds
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How Super Gro Works Its Magic</h2>

          <div className="steps-container">
            <div className="step">
              <h3>Step 1: Root Explosion (Days 1-7)</h3>
              <p>
                The moment Super Gro touches your soil, beneficial
                microorganisms activate. They break down organic matter and
                release nutrients in forms your plants can instantly absorb.
              </p>
            </div>

            <div className="step">
              <h3>Step 2: Photosynthesis Supercharge (Days 7-14)</h3>
              <p>
                The seaweed extract and humic acid increase chlorophyll
                production. Your leaves turn darker green because they're
                producing more food through photosynthesis.
              </p>
            </div>

            <div className="step">
              <h3>Step 3: Disease Shield Activation (Days 14-21)</h3>
              <p>
                The beneficial microbes form a protective barrier around your
                plants. They crowd out harmful fungi and bacteria before they
                can cause disease.
              </p>
            </div>

            <div className="step">
              <h3>Step 4: Maximum Production (Week 4 to Harvest)</h3>
              <p>
                With strong roots, efficient photosynthesis, and disease
                protection working together, your crops reach their genetic
                potential.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Options */}
      <section className="payment-options">
        <div className="container">
          <h2 className="section-title">
            Choose Your Payment Method & Start Growing Better Crops
          </h2>
          <p className="section-subtitle">
            Both options come with our 30-day money-back guarantee
          </p>

          <div className="payment-cards">
            <div className="payment-card recommended">
              <div className="card-header">
                <h3>Pay Online with PayStack</h3>
                <span className="badge badge-success">MOST POPULAR ⭐</span>
              </div>
              <div className="card-body">
                <div className="price-box">
                  <div className="original-price">₦90,500</div>
                  <div className="current-price">₦55,000</div>
                  <div className="savings">💰 You save ₦5,000 instantly</div>
                </div>
                <ul className="features">
                  <li>✅ Bank transfer, card, or USSD payment</li>
                  <li>✅ Instant order confirmation via SMS & Email</li>
                  <li>✅ Priority processing - ships same day</li>
                  <li>✅ Real-time order tracking</li>
                  <li>✅ Dedicated customer support line</li>
                  <li>✅ Save ₦5,000 compared to pay on delivery</li>
                </ul>
                <button
                  className="btn btn-secondary btn-block"
                  onClick={() => handleOrderClick("pay_online_button", "payment_section")}
                >
                  💳 PAY ONLINE & SAVE ₦5,000 NOW
                </button>
                <p className="payment-security">
                  🔒 Secure payment powered by PayStack | 256-bit SSL encryption
                </p>
              </div>
            </div>

            <div className="payment-card">
              <div className="card-header">
                <h3>Pay on Delivery</h3>
                <span className="badge badge-warning">CASH READY?</span>
              </div>
              <div className="card-body">
                <div className="price-box">
                  <div className="current-price">₦55,000</div>
                  <div className="savings">Standard price - no discount</div>
                </div>
                <div className="alert alert-warning">
                  <strong>⚠️ CRITICAL REQUIREMENT:</strong> You MUST be
                  physically present at your delivery address with cash ready.
                </div>
                <ul className="features">
                  <li>✅ Inspect product before payment</li>
                  <li>✅ Pay with cash or instant bank transfer</li>
                  <li>✅ Same 48-72 hour nationwide delivery</li>
                  <li>✅ Delivery agent calls 30 minutes before arrival</li>
                </ul>
                <button
                  className="btn btn-primary btn-block"
                  onClick={() => handleOrderClick("pay_on_delivery_button", "payment_section")}
                >
                  📦 ORDER WITH PAY ON DELIVERY
                </button>
                <p className="payment-tip">
                  💡 Tip: Choose online payment to save ₦5,000 and avoid
                  re-delivery risks
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bulk Discount Offers */}
<section className="bulk-offers">
  <div className="container">
    <h2 className="section-title">
      Buy More, Save More! <span className="highlight-green">Get ₦5,000 Discount Per Extra Unit</span>
    </h2>
    <p className="section-subtitle">
      Stock up and maximize your farm's potential – the more you buy, the more you save!
    </p>

    <div className="bulk-cards">
      {/* Card for 1 unit */}
      <div className="bulk-card">
        <div className="bulk-quantity">1 Unit</div>
        <div className="bulk-price">
          <span className="original-price">₦90,500</span>
          <span className="discounted-price">₦55,000</span>
        </div>
        <div className="bulk-savings">Save ₦0</div>
        <button
          className="btn btn-primary btn-block"
          onClick={() => handleOrderClick("bulk_buy_1_unit", "bulk_offers")}
        >
          ORDER 1 UNIT
        </button>
      </div>

      {/* Card for 2 units */}
      <div className="bulk-card recommended">
        <div className="card-header">
          <span className="badge badge-success">BEST VALUE ⭐</span>
        </div>
        <div className="bulk-quantity">2 Units</div>
        <div className="bulk-price">
          <span className="original-price">₦140,000</span>
          <span className="discounted-price">₦130,000</span>
        </div>
        <div className="bulk-savings">You save ₦10,000</div>
        <button
          className="btn btn-secondary btn-block"
          onClick={() => handleOrderClick("bulk_buy_2_units", "bulk_offers")}
        >
          ORDER 2 UNITS
        </button>
      </div>

      {/* Card for 3 units */}
      <div className="bulk-card">
        <div className="bulk-quantity">3 Units</div>
        <div className="bulk-price">
          <span className="original-price">₦210,000</span>
          <span className="discounted-price">₦190,000</span>
        </div>
        <div className="bulk-savings">You save ₦10,500</div>
        <button
          className="btn btn-primary btn-block"
          onClick={() => handleOrderClick("bulk_buy_3_units", "bulk_offers")}
        >
          ORDER 3 UNITS
        </button>
      </div>
    </div>

    <p className="bulk-note">
      💡 Discount applies automatically at checkout. For larger quantities, please call us.
    </p>
  </div>
</section>

      {/* Testimonials */}
      <section className="testimonials">
        <div className="container">
          <h2 className="section-title">Join 10,500+ Happy Nigerian Farmers</h2>
          <p className="section-subtitle">
            These farmers took action - now they're reaping the rewards
          </p>

          <div className="testimonial-cards">
            <div className="testimonial-card">
              <div className="testimonial-image">
                <img src={farm} alt="Farm testimonial" className="responsive-img" />
              </div>
              <div className="testimonial-content">
                <p>
                  "I was skeptical because I've tried many fertilizers before.
                  But Super Gro is different. My maize harvest increased from
                  2.3 tons to 3.2 tons per acre."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Mr. Adebayo Ogunleye</strong>
                <span>Maize Farmer | Oyo State | 5 Acres</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-image">
                <img src={chika} alt="Vegetable farmer" className="responsive-img" />
              </div>
              <div className="testimonial-content">
                <p>
                  "My tomatoes used to have so many problems - yellow leaves,
                  small fruits, diseases. After 3 weeks with Super Gro,
                  everything changed."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Mrs. Chikaodi Nwosu</strong>
                <span>Vegetable Farmer | Delta State | Greenhouse</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-image">
                <img src={riceFarm} alt="Rice farm" className="responsive-img" />
              </div>
              <div className="testimonial-content">
                <p>
                  "I farm rice commercially - 10 acres. Used Super Gro on 5
                  acres as a test. The difference was shocking."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Alhaji Ibrahim Abubakar</strong>
                <span>Rice Farmer | Kano State | 10 Acres</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-image">
                <img src={fishholding} alt="Fish farm" className="responsive-img" />
              </div>
              <div className="testimonial-content">
                <p>
                  "I never knew you could use fertilizer in fish farming until I
                  read about Super Gro. I added it to my pond and within 2
                  weeks..."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Mr. Emeka Okafor</strong>
                <span>Fish Farmer | Anambra State | 4 Ponds</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-image">
                <img src={plantain} alt="Plantain farm" className="responsive-img" />
              </div>
              <div className="testimonial-content">
                <p>
                  "My plantain farm was my retirement plan but the yields were
                  disappointing. Started using Super Gro monthly and the
                  transformation was amazing."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Mrs. Funke Adeleke</strong>
                <span>Plantain Farmer | Ondo State | 3 Acres</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-image">
                <img src={pepper} alt="Pepper farm" className="responsive-img" />
              </div>
              <div className="testimonial-content">
                <p>
                  "Delivery was fast - 2 days to Calabar. The product works
                  exactly as they described. My pepper plants came back to life."
                </p>
              </div>
              <div className="testimonial-author">
                <strong>Mr. Samuel Bassey</strong>
                <span>Pepper Farmer | Cross River State | 1 Acre</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq">
        <div className="container">
          <h2 className="section-title">Your Questions Answered</h2>
          <p className="section-subtitle">
            Everything you need to know before ordering
          </p>

          <div className="faq-list">
            <div className="faq-item">
              <h3>❓ How quickly will I see results on my farm?</h3>
              <p>
                You'll notice changes within 2 weeks - darker green leaves and
                stronger stems. By week 4, the difference will be obvious.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ How long does delivery take?</h3>
              <p>
                48-72 hours to most locations in Nigeria. We ship from Lagos, so
                nearby states get it faster (1-2 days).
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ What crops can I use Super Gro on?</h3>
              <p>
                Almost everything! Grains, root crops, vegetables, fruits, cash
                crops, and even for fish ponds.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ How do I apply Super Gro correctly?</h3>
              <p>
                Simple: Mix 1 milliliter (about 20 drops) with 1 liter of water.
                Apply as foliar spray on leaves and as soil drench around the
                roots.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ Is Super Gro safe for organic farming?</h3>
              <p>
                Absolutely! Super Gro is 100% organic and certified for organic
                farming. No synthetic chemicals, no harmful additives.
              </p>
            </div>

            <div className="faq-item">
              <h3>❓ How much land does one 5L bottle cover?</h3>
              <p>
                One bottle covers 1-2 acres for an entire growing season
                (3-4 months), depending on your crop type.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="guarantee-section">
        <div className="container">
          <div className="guarantee-content">
            <div className="guarantee-icon">✅</div>
            <h2>Our Iron-Clad 30-Day Guarantee</h2>
            <p>
              We're so confident Super Gro will transform your farm that we
              offer this simple promise:
            </p>

            <div className="guarantee-box">
              <p>
                Use Super Gro exactly as directed for 30 days. If you don't see
                healthier plants, stronger growth, and visible improvement in
                your crops, simply contact us. We'll refund every naira - no
                questions asked.
              </p>

              <p className="guarantee-note">
                Why can we offer this guarantee? Because Super Gro works. Over
                10,500 farmers trust us.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="container">
          <div className="cta-content">
            <h2>This is Your Moment - Take Action Now!</h2>
            <p>
              You've seen the proof. You've read the testimonials. You
              understand how Super Gro works.
            </p>

            <div className="urgency-elements">
              <div className="stock-counter">
                <div className="stock-text">
                  ⚠️ Only 47 bottles remaining in this batch
                </div>
                <div className="stock-bar">
                  <div className="stock-fill"></div>
                </div>
                <p className="stock-note">
                  Next shipment arrives in 2 weeks - don't wait that long!
                </p>
              </div>

              <div className="delivery-timer">
                <span className="timer-icon">⏰</span>
                <span className="timer-text">
                  Orders placed in the next 6 hours ship TODAY
                </span>
              </div>
            </div>

            <button
              className="btn btn-secondary cta-button-large"
              onClick={() => handleOrderClick("final_cta_button", "final_section")}
            >
              👉 YES! SEND ME SUPER GRO NOW
            </button>

            <div className="guarantee-badge">
              <span className="guarantee-icon">✅</span>
              <span className="guarantee-text">
                Protected by Our 30-Day Money-Back Guarantee
              </span>
            </div>

            <div className="stats-grid">
              <div className="stat">
                <div className="stat-number">10,500+</div>
                <div className="stat-label">Farmers Trust Us</div>
              </div>
              <div className="stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Average Yield Increase</div>
              </div>
              <div className="stat">
                <div className="stat-number">98%</div>
                <div className="stat-label">Satisfaction Rate</div>
              </div>
              <div className="stat">
                <div className="stat-number">48hrs</div>
                <div className="stat-label">Fast Delivery</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>The Peters Agricultural Produce</h4>
              <p>Transforming Nigerian Agriculture Since 2023</p>
              <p className="footer-note">
                We're more than a product company - we're your partners in
                farming success.
              </p>
            </div>

            <div className="footer-section">
              <h4>Contact Us</h4>
              <p>📞 0705-526-8702</p>
              <p>📧 support@thepetersholding.com</p>
              <p>🕒 Mon-Sat: 8AM - 6PM</p>
              <p className="footer-note">
                Questions before ordering? Call us! We're here to help you
                succeed.
              </p>
            </div>

            <div className="footer-section">
              <h4>Nationwide Delivery</h4>
              <p>✅ All 36 States + FCT</p>
              <p>✅ 48-72 Hour Delivery</p>
              <p>✅ Secure Packaging</p>
              <p>✅ Track Your Order</p>
              <p className="footer-note">
                From Lagos to Maiduguri - we deliver Super Gro to your farm gate
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>© 2023 The Peters Agricultural Produce. All rights reserved.</p>
            <p className="footer-copyright">
              Super Gro® is a registered product. We are committed to
              sustainable agriculture and farmer prosperity.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
